export const getIconUrl = (icon: string): string => {
    return `${process.env.REACT_APP_ORIGIN}/icon/${icon}`; 
}

export const getImageUrl = (image: string): string => {
    return `${process.env.REACT_APP_ORIGIN}/image/${image}`; 
}